
  export const headers = {
    initialHeaders: [
      { title: "Fecha de creación", field: "creationDate", child: null },
      { title: "Nombre de cláusula", field: "name", child: null },
    ],
    otherHeaders: [
      { title: "Definción de cláusula", field: "definitionClause", child: null },
    ],
  };
  